import { render, staticRenderFns } from "./TransferPersonalInfo.vue?vue&type=template&id=c2611540&scoped=true&"
import script from "./TransferPersonalInfo.vue?vue&type=script&lang=js&"
export * from "./TransferPersonalInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2611540",
  null
  
)

export default component.exports